import React from 'react';

function MatchingVehiclesForArticle(props) {
    

    return (
        <div>
            {props.vehicles &&
                <ul className="list-unstyled">
                {props.vehicles.map(v => {
                    return <li className="vehicleProductListComponent-boxRow" key={v.carId} modelid={v.modelId} carid={v.carId}>{v.modelName} {v.typeName}</li>
                    })}
                </ul>
            }
        </div>
    );
}
export default MatchingVehiclesForArticle;